import React from 'react';
import { View, type ViewProps } from 'react-native';
import { cn } from '@/utils/cn';

export interface ProgressProps extends ViewProps {
  value?: number; // 0-100
  className?: string;
  indicatorClassName?: string;
}

export function Progress({ value = 0, className, indicatorClassName, ...props }: ProgressProps) {
  const clampedValue = Math.min(Math.max(value, 0), 100);

  if (__DEV__ && (!Number.isFinite(clampedValue) || clampedValue < 0 || clampedValue > 100)) {
     
    console.log('[Progress] invalid value', { value, clampedValue });
  }

  return (
    <View
      className={cn(
        'relative h-2 w-full overflow-hidden rounded-full bg-neutral-200',
        className,
      )}
      {...props}
    >
      <View
        className={cn('bg-primary h-full rounded-full transition-all', indicatorClassName)}
        style={{ width: `${clampedValue}%` }}
      />
    </View>
  );
}
